import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { DOCUMENT_TITLE, PORTAL_DOCUMENT_TITLE } from '../../constants/productBranding';

export function DocumentTitleManager(): null {
  const location = useLocation();

  useEffect(() => {
    document.title = location.pathname.startsWith('/portal') ? PORTAL_DOCUMENT_TITLE : DOCUMENT_TITLE;
  }, [location.pathname]);

  return null;
}
